import type { EditableLineItem } from '@/components/organisms/OptionCard';
import { calcLineSubtotal } from '@/lib/sales/pricingMode';
import type { ProposalTemplateLineItem } from '@/types/proposalTemplate';

export function proposalTemplateLineItemToDto(li: EditableLineItem): ProposalTemplateLineItem {
  return {
    rowId: li.rowId ?? li._rowId,
    lineItemId: li.lineItemId,
    itemVersion: li.itemVersion,
    name: li.name,
    code: li.code,
    type: li.type,
    unit: li.unit,
    description: li.description,
    basePrice: li.basePrice,
    laborRate: li.laborRate,
    laborCostRate: li.laborCostRate,
    laborCostLines: li.laborCostLines,
    costBasis: li.costBasis ?? 0,
    markupPercent: li.markupPercent ?? 0,
    chargeable: li.chargeable,
    pricingTreatment: li.pricingTreatment ?? null,
    markupOverride: li.markupOverride ?? null,
    hiddenFromCustomer: li.hiddenFromCustomer,
    visibleToCustomer: li.visibleToCustomer,
    estimatedHours: li.estimatedHours ?? null,
    currency: 'USD',
    priceStrategy: li.priceStrategy || 'FLAT',
    taxable: li.taxable,
    pricebookTaxable: li.pricebookTaxable,
    taxCategory: li.taxCategory ?? null,
    taxCode: li.taxCode ?? null,
    taxLineType: li.taxLineType ?? null,
    glAccount: li.glAccount ?? null,
    glCogs: li.glCogs ?? null,
    glExpenseAccount: li.glExpenseAccount ?? null,
    glClass: li.glClass ?? null,
    displayConfig: li.displayConfig ?? null,
    dynamicPricingConfig: li.dynamicPricingConfig,
    manualPriceOverride: li.manualPriceOverride ?? null,
    memberPrice: li.memberPrice ?? null,
    memberDiscountPercent: li.memberDiscountPercent ?? null,
    lineKey: li.lineKey,
    parentLineKey: li.parentLineKey,
    componentDisplayMode: li.componentDisplayMode,
    configurationName: li.configurationName,
    source: li.isCustom ? 'MANUAL' : 'CATALOG',
    quantity: li.quantity,
    lineTotal: calcLineSubtotal(li),
    isOptional: li.isOptional,
    isSelected: li.isSelected,
    ...(li.membershipPlanId ? { membershipPlanId: li.membershipPlanId } : {}),
    ...(li.membershipBillingOptionId
      ? { membershipBillingOptionId: li.membershipBillingOptionId }
      : {}),
  };
}
